import { notifications } from '@mantine/notifications';
import { Modal, ControlledFileInput, Button } from '@shared/ui';
import { useForm } from 'react-hook-form';
import { useUpdateOrderReady } from '@modules/orders';
import type { FileInputValue } from '@shared/ui/FileInput';

interface OrderReadyModalProps {
  isOpen: boolean;
  onClose: () => void;
  orderId: number;
}

interface OrderReadyFormData {
  images: FileInputValue[] | null;
}

export default function OrderReadyModal({ isOpen, onClose, orderId }: OrderReadyModalProps) {
  const updateOrderReadyMutation = useUpdateOrderReady();
  const { control, handleSubmit, reset, formState: { errors } } = useForm<OrderReadyFormData>({
    defaultValues: {
      images: [],
    },
  });

  const onSubmit = async (data: OrderReadyFormData) => {
    try {
      // Извлекаем только файлы (не объекты с url)
      const images = data.images || [];
      const files = images.filter((img): img is File => img instanceof File);

      if (files.length === 0) {
        notifications.show({
          title: 'Ошибка',
          message: 'Пожалуйста, загрузите хотя бы одно фото',
          color: 'red',
        });
        return;
      }

      await updateOrderReadyMutation.mutateAsync({
        orderId,
        files,
      });

      notifications.show({
        title: 'Успешно',
        message: 'Заказ отмечен как готов',
        color: 'green',
      });

      reset();
      onClose();
    } catch (error) {
      console.error('Ошибка при обновлении статуса заказа:', error);
      notifications.show({
        title: 'Ошибка',
        message: 'Не удалось обновить статус заказа',
        color: 'red',
      });
    }
  };

  const handleClose = () => {
    reset();
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title="Прикрепите фото готового букета"
      size="md"
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <div style={{ marginBottom: '20px' }}>
          <ControlledFileInput
            name="images"
            control={control}
            multiple
            error={errors.images?.message}
          />
        </div>

        <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
          <Button
            type="button"
            variant="secondary"
            onClick={handleClose}
          >
            Отмена
          </Button>
          <Button
            type="submit"
            variant="primary"
            loading={updateOrderReadyMutation.isPending}
            disabled={updateOrderReadyMutation.isPending}
          >
            Сохранить
          </Button>
        </div>
      </form>
    </Modal>
  );
}
